<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="AtomicRanchBook_0005_001" id="d14e107" src="images/AtomicRanchBook_0005_001.jpg"/></p><p class="ct" id="d7e2185"><b>Contents </b></p>
<p class="cct" id="d7e2235"><a href="#/Grin_ISBN9781423600022_epub_c16_r1#d7e1" id="d6e1">Introduction</a></p>
<p class="cct" id="d7e2265"><a href="#/Grin_ISBN9781423600022_epub_c17_r1#d7e2" id="d6e2">Inspiring Originals</a></p>
<p class="cct" id="d7e2295"><span href="#/Grin_ISBN9781423600022_epub_c18_r1#d7e3" id="d6e3" title="Link target outside of Sample">Is My House a Ranch?</span></p>
<p class="cct" id="d7e2345"><span href="#/Grin_ISBN9781423600022_epub_c19_r1#d7e4" id="d6e4" title="Link target outside of Sample">Stunning Transformations</span></p>
<p class="cct" id="d7e2375"><span href="#/Grin_ISBN9781423600022_epub_c20_r1#d7e5" id="d6e5" title="Link target outside of Sample">Modest Makeovers</span></p>
<p class="cct" id="d7e2425"><span href="#/Grin_ISBN9781423600022_epub_c21_r1#d7e6" id="d6e6" title="Link target outside of Sample">Pure Fun</span></p>
<p class="cct" id="d7e2465"><span href="#/Grin_ISBN9781423600022_epub_c22_r1#d7e7" id="d6e7" title="Link target outside of Sample">Outside the Ranch</span></p>
<p class="cct" id="d7e2495"><span href="#/Grin_ISBN9781423600022_epub_c23_r1#d7e8" id="d6e8" title="Link target outside of Sample">Adding Personality</span></p>
<p class="cct" id="d7e2525"><span href="#/Grin_ISBN9781423600022_epub_c24_r1#d7e9" id="d6e9" title="Link target outside of Sample">Preserving Midcentury Neighborhoods</span></p>
<p class="cct" id="d7e2575"><span href="#/Grin_ISBN9781423600022_epub_c25_r1#d7e10" id="d6e10" title="Link target outside of Sample">Ranch Resources</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Grin_ISBN9781423600022_epub_c15_r1.vue?aa554746